
export default {
    name: 'LeePay',
    data() {
        return {
            show: false,
            tempay: '',
        };
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default() {
                return {
                    bg: '#409eff',
                    choose: ['微信支付', '支付宝', '花呗支付', '农业银行']
                }
            }
        }
    },
    methods: {
        sel(el) {
            this.tempay = el
        },
        chuli() {
            this.$emit('change',this.tempay)
            this.$emit('input',false)
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.show = value
            }
        }
    },
};
